<template>
    <div class="text-base text-gray-600 ml-4 mr-4 flex items-center cursor-pointer hover:text-gray-700" @click="showDialog=true">
        <font-awesome-icon :icon="['fas', 'comment']" /> <div class="ml-2">Add to list </div>

        <jet-dialog-modal
            v-if="showDialog"
            :show="showDialog"
            @close="showDialog = false "
        >
            <template #title>
                Add {{ selectedNoun }} to list
            </template>

            <template #content>
                Which list would you like to add these contacts to? <br />
                <group-select
                    v-model="selectedGroup"
                    class="w-64 bg-white"
                />
            </template>

            <template #footer>
                <button @click="modalClose">
                    Cancel
                </button>

                <jet-button
                    v-if="listTitle"
                    class="ml-8"
                    @click.native="updateContacts"
                    :disabled="loading"
                >
                    Add {{selectedFormatted}} {{ selectedNoun }} to {{ listTitle }}
                </jet-button>
            </template>
        </jet-dialog-modal>
    </div>
</template>

<script>
import {mapWritableState, mapActions} from 'pinia';
import { useGeneralTableStore } from '@/Stores/general_table';
import groupSelect from '@/components/GroupSelect.vue';

export default {
    name: 'ContactTableActionAddToList',
    components: {
        groupSelect,
    },
    data: () => ({
        showDialog: false,
        selectedGroup: null,
        loading: false,
    }),
    computed: {
        ...mapWritableState(useGeneralTableStore, ['selected', 'selectedFormatted', 'selectedNoun', ]),
        listTitle() {
            if (!this.selectedGroup) return '';
            return this.selectedGroup.title;
        }
    },
    methods: {
        ...mapActions(useGeneralTableStore, ['clearData', 'fetchData']),
        updateContacts() {
            this.loading = true;
            axios.post(route('contacts.addToList'), {
                tra_ids: this.selected.map(item => item.tra_id),
                group_tra_id: this.selectedGroup.tra_id
            }).then(response => {
                this.$toasted.show(this.selectedFormatted + ' ' + this.selectedNoun +  ' added to ' + this.listTitle, {
                    position: 'bottom-right',
                    type: 'success',
                    duration: 2000,
                });
                this.clearData();
                this.fetchData();
            })
            .catch(error => {
                this.$toasted.show('An error occurred', {
                    position: 'bottom-right',
                    type: 'error',
                    duration: 2000,
                });
            });
        },
        modalClose() {
            this.showDialog = false;
        }
    }
}

</script>